export const cardMixin = {
  props: { config: { type: Object, default: () => {} }},
  methods: {
    settings() {
      const { topic, k } = this.config
      this.$refs.modal.init({ topic, k })
    }
  }
}

export const modalMixin = {
  data() {
    return {
      config: { topic: '', k: '' }
    }
  },
  methods: {
    init(config) {
      this.$$examApi.getkeyvaluebykey({ ...config })
        .then(res => {
          const { result, message, v } = res.data
          if ([0, 13].includes(result)) {
            this.config = { ...this.config, ...config }
            this.visible = true
            if (result === 0) {
              this.onSuccess && this.onSuccess(v)
            } else {
              this.onNotInited && this.onNotInited()
            }
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}
